import { observer } from 'mobx-react-lite';
import { Suspense, SyntheticEvent, useState } from 'react';
// import { useHistory } from "react-router-dom";
import {
  Card,
  Header,
  Grid,
  Icon,
  Label,
  Segment,
  Form,
  Input,
  Button,
  Checkbox,
} from 'semantic-ui-react';
import { TemplateSubTasks, TemplateTask } from '../../../app/models/template';
import { useStore } from '../../../app/stores/store';
import { v4 as uuid } from 'uuid';
import WorkflowSettingsElements from './WorkflowElements';
import {
  DragDropContext,
  Draggable,
  Droppable,
  DropResult,
} from 'react-beautiful-dnd';
import { useEffect } from 'react';
import {
  errorDot,
  errorEmptyText,
  errorMessageText,
  selectionEmptyErrorMsg,
} from '../../../app/common/form/errorMessageText';
import sendRespectiveEmail from '../../../app/models/EmailNew';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import AutoRejectSetting from './autoRejectSetting';
import { TemplateSubTaskType } from './autoRejectSetting/type';
import { useNavigate } from 'react-router-dom';
import DeleteModal from '../../../library/deleteModal';

const cardStyleLevel2 = {
  display: 'inline-block',
  padding: '10px',
  height: '70vh',
  width: '200pt',
  marginTop: '120px',
  color: 'black',
  cursor: 'pointer',
  marginLeft: '2px',
  boxShadow: '5px 5px 10px lightgray',
};
const cardcolor = { backgroundColor: 'lightgray', color: 'black' };

function WorkflowSubtasks() {
  const {
    workflowConfigurationStore,
    userStore,
    RolesAndPermissionsIDStore,
    mediaAssetStore,
    TemplateStore,
    commonStore,
  } = useStore();
  const history = useNavigate();
  //const declaration
  const {
    selectedTasks,
    loadSubTaskById,
    createSubtaskUnderTask,
    selectedSubTasks,
    loadingInitialST,
    editSubTasks,
    subTaskelementToggleOffEdit,
    deleteSubTask,
    selectedTemplate,
    editTasks,
    cloneSubTasks,
    
  } = TemplateStore;
  const [getnewsubtaskkey, setgetnewsubtaskkey] = useState<string | null>();
  const [newSubtasks, setNewSubtasks] = useState('');
  const [tempSubTasks, setTempSubTasks] = useState<
    TemplateSubTasks[] | undefined | TemplateSubTaskType[]
  >(selectedTasks?.subTasks);
  const [errorType, setErrorType] = useState<string>('');
  const [isAutoRejectModal, setIsAutoRejectModal] = useState<boolean>(false);
  const [autoRejectSubTaskId, setAutoRejectSubtaskId] = useState<string>('');
  const [templateSubTasks, setTemplateSubTasks] = useState<TemplateSubTasks>({
    subTaskId: '',
    subTaskName: '',
    subTaskDateTime: '',
    templateSubtaskId: '',
    isActive: false,
    isDeleted: false,
    subtaskIndex: 0,
    elements: [],
    communication: [],
    files: [],
    subTaskstatus: 0,
    api: [],
  });
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    setErrorType('');
    setTempSubTasks(selectedTasks?.subTasks);
  }, [selectedTasks]);

  //////////////this function to handle when Enter Key is pressed
  const handleKeyPress = (e: any) => {
    if (
      e.key === 'Enter' &&
      workflowConfigurationStore.WorkflowConfiguration.editClickedSubtask ===
        false &&
      errorType !== 'dot' &&
      errorType !== 'EmptyName' &&
      errorType !== 'SameName' &&
      !/\s/g.test(newSubtasks?.charAt(0) || '')
    ) {
      hanldeAddSubTasks();
    }
    if (
      e.key === 'Enter' &&
      workflowConfigurationStore.WorkflowConfiguration.editClickedSubtask ===
        true &&
      errorType !== 'dot' &&
      errorType !== 'EmptyName' &&
      errorType !== 'SameName' &&
      !/\s/g.test(newSubtasks?.charAt(0) || '')
    ) {
      handleSaveEdited('edit');
    }
  };
  //////////////this function to handle SubData
  const handleSubData = (e: any, id: string) => {
    if (
      workflowConfigurationStore.WorkflowConfiguration.disableClick === false
    ) {
      setErrorType('');
      loadSubTaskById(id); // load elements
      workflowConfigurationStore.setSubTaskName(id); //Card Color Subtask
      workflowConfigurationStore.setShowElementCard(true); //Show Element
      workflowConfigurationStore.setAssetTypeIsActive(true);
      mediaAssetStore.openLink(e.currentTarget.textContent);
    }
    //Edit Cancel
    workflowConfigurationStore.resetEditClickedButtonExceptSubTask();
  };
  ////////////////// function checks for same name
  const handleChangeName = (e: SyntheticEvent, data: any) => {
    setNewSubtasks(data.value);
    const NameCheck = tempSubTasks?.some(function (el) {
      function ciEquals(a: string, b: string) {
        return typeof a === 'string' && typeof b === 'string'
          ? a.trim().localeCompare(b.trim(), undefined, {
              sensitivity: 'accent',
            }) === 0
          : a.trim() === b.trim();
      }
      return ciEquals(el.subTaskName, data.value);
    });
    setErrorType(NameCheck ? 'SameName' : ''); //check name exists
    if (data.value.includes('.')) {
      setErrorType('dot');
    }
  };
  ////////////////////////////// Toggle On Off function
  const toggleSubOn = (
    _event: SyntheticEvent,
    data: any,
    subtask: TemplateSubTasks,
  ) => {
    subTaskelementToggleOffEdit(subtask.subTaskId);

    workflowConfigurationStore.setShowElementClicked(data.checked);
  };
  ////////////////////////// Sub Task Update Front End Schema and Backend API Call
  const hanldeAddSubTasks = () => {
    if (
      selectedTasks &&
      selectedTemplate !== undefined &&
      newSubtasks.length !== 0 &&
      errorType !== 'dot' &&
      errorType !== 'EmptyName' &&
      errorType !== 'SameName' &&
      !/\s/g.test(newSubtasks?.charAt(0) || '')
    ) {
      const IdForReference = uuid();
      const subTasks = selectedTasks?.subTasks as TemplateSubTasks[];
      const newArr = {
        subTaskId: IdForReference,
        subTaskName: newSubtasks,
        subTaskDateTime: new Date().toISOString(),
        isActive: true,
        templateSubtaskId: IdForReference.toString(),
        subtaskIndex: subTasks.length === 0 ? 0 : subTasks.length + 1,
        isDeleted: false,
        elements: [],
        communication: [],
        files: [],
        subTaskstatus: 0,
        api: [],
      };
      const selectedTasksArr = {
        // for backend
        ...selectedTasks,
        subTasks: [newArr],
      };
      subTasks.push(newArr as TemplateSubTasks); // for front end schema
      const AllvaluefrontEndData = {
        ...selectedTasks,
        subTasks: subTasks,
      };
      //For roles and permissions
      const newRoleArr = {
        id: uuid(),
        itemId: IdForReference,
        rolesId:
          userStore.user?.roleId !== undefined ? userStore.user?.roleId : '',
      };
      createSubtaskUnderTask(selectedTasksArr, AllvaluefrontEndData);
      sendRespectiveEmail('created', newArr.subTaskName, 'Created Subtask', ''); //email Function
      RolesAndPermissionsIDStore.createRoleID(newRoleArr);
    } else {
      setErrorType('EmptyName');
    }
    setNewSubtasks(''); // set value to empty
  };

  ///////////////////////////clone Data and generate new id
  const handleClone = () => {
    let flag = 0;
    selectedTasks?.subTasks?.forEach((data) => {
      if (data.subTaskId === selectedSubTasks?.subTaskId) {
        flag = 1;
      }
    });
    if (
      selectedSubTasks &&
      selectedTasks !== undefined &&
      newSubtasks.length > 0 &&
      errorType !== 'dot' &&
      !/\s/g.test(newSubtasks?.charAt(0) || '')
    ) {
      cloneSubTasks({
        id: selectedTasks.taskId,
        cloned_from: selectedSubTasks.subTaskId,
        cloned_as: newSubtasks,
      });
      sendRespectiveEmail('cloned', newSubtasks, 'Cloned Subtask', ''); //email Function
    } else if (!flag) {
      setErrorType('selectionEmpty');
    } else if (newSubtasks.length === 0) {
      setErrorType('EmptyName');
    }
    setNewSubtasks(''); // set value to empty
  };
  //////////////////////////////Drag and Drog
  const onDragEnd = (result: DropResult) => {
    loadSubTaskById(result.draggableId);
    if (tempSubTasks !== undefined && selectedSubTasks !== undefined) {
      const { source, destination } = result;
      if (!destination) return;
      const items = Array.from(tempSubTasks as TemplateSubTasks[]);
      const [newOrder] = items.splice(source.index, 1);
      items.splice(destination.index, 0, newOrder);
      setTempSubTasks(items);
      const updatedIndex = items.map((data, index) => {
        const newArr = {
          ...data,
          subtaskIndex: index, //editing the task index
        };
        return newArr;
      });
      if (selectedTasks !== undefined) {
        const selectedTasksArr = {
          ...selectedTasks,
          subTasks: updatedIndex,
        };
        editTasks(selectedTasksArr);
      }
    }
  };
  //////////////////////////////////// Edit Click Function
  const handleEdit = (id: string, name: string) => {
    setErrorType('');
    loadSubTaskById(id);
    setNewSubtasks(name);
    workflowConfigurationStore.setEditClickedSubTask(true);
  };
  const redirectUserToCommunication = (
    subtasks: TemplateSubTasks,
    path: string,
  ) => {
    TemplateStore.loadSubTaskById(subtasks.subTaskId);
    history(path);
  };
  //////////////////////////////////// Save Edited
  const handleSaveEdited = (name: string) => {
    if (
      selectedTasks &&
      selectedSubTasks !== undefined &&
      name === 'edit' &&
      newSubtasks.length !== 0
    ) {
      const newArr = {
        ...selectedSubTasks,
        subTaskName: newSubtasks,
      };
      editSubTasks(newArr);
      sendRespectiveEmail('edited', newArr.subTaskName, 'Edited Subtask', ''); //email Function
      ///////////////////to update dom
      const data = selectedTasks?.subTasks;
      const index = data.findIndex(
        (obj: { subTaskId: string }) =>
          obj.subTaskId === selectedSubTasks.subTaskId,
      );
      data[index].subTaskName = newSubtasks;
    }
    setNewSubtasks('');
    workflowConfigurationStore.setEditClickedSubTask(false);
  };
  ///////////////////////Delete SubTask
  const handleDeleteSubTask = (subtasks: TemplateSubTasks) => {
    if (selectedTasks !== undefined) {
      setErrorType('');
      setTemplateSubTasks(subtasks);
      setIsModalOpen(true);
    }
  };
  const deleteConfirmed = () => {
    const subTaskDatas = selectedTasks?.subTasks as TemplateSubTasks[];
    const subTaskArr = {
      ...templateSubTasks,
      isDeleted: true,
    };
    //  const frontEndArr to show Delete
    const filterData = subTaskDatas.filter(
      (item) => item.subTaskId !== templateSubTasks.subTaskId,
    );
    const AllvaluefrontEndData = {
      ...selectedTasks,
      subTasks: filterData,
    };
    deleteSubTask(subTaskArr, AllvaluefrontEndData as TemplateTask);
    sendRespectiveEmail(
      'deleted',
      subTaskArr.subTaskName,
      'Deleted Subtask',
      '',
    ); //email Function
    setIsModalOpen(false);
  };
  const SubTaskDataJSX = (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable">
        {(provided) => (
          <div
            className="templatepreset workflow-config-subtasks"
            {...provided.droppableProps}
            ref={provided.innerRef}
          >
            {tempSubTasks?.map((subtasks, index) => {
              return (
                <Draggable
                  key={subtasks.subTaskId}
                  draggableId={subtasks.subTaskId}
                  index={index}
                >
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <Card>
                        <Card.Content
                          onClick={(e: any) =>
                            handleSubData(e, subtasks.subTaskId)
                          }
                          onMouseEnter={() =>
                            setgetnewsubtaskkey(subtasks.subTaskId)
                          }
                          onMouseLeave={() => setgetnewsubtaskkey(null)}
                          style={
                            subtasks.subTaskId ===
                            workflowConfigurationStore.WorkflowConfiguration
                              .subTaskName
                              ? cardcolor
                              : null
                          }
                          key={subtasks.subTaskId}
                        >
                          <Grid className="hoverColor" columns={3}>
                            <Grid.Row>
                              <Grid.Column
                                width={2}
                                style={{
                                  padding: '0',
                                }}
                              >
                                {getnewsubtaskkey === subtasks.subTaskId ? (
                                  <div
                                    style={{
                                      display: 'flex',
                                    }}
                                    {...provided.dragHandleProps}
                                  >
                                    <Icon
                                      style={{
                                        cursor: 'all-Scroll',
                                        fontSize: '17px',
                                        marginTop: '2px',
                                      }}
                                      name="ellipsis vertical"
                                      color="grey"
                                      size="small"
                                    />
                                    <Icon
                                      style={{
                                        cursor: 'all-Scroll',
                                        fontSize: '17px',
                                        left: 7,
                                        position: 'absolute',
                                        marginTop: '2px',
                                      }}
                                      name="ellipsis vertical"
                                      color="grey"
                                      size="small"
                                    />
                                  </div>
                                ) : null}
                              </Grid.Column>
                              <Grid.Column width={12}>
                                {subtasks.subTaskName}
                              </Grid.Column>
                              <Grid.Column
                                width={2}
                                style={{
                                  padding: '0',
                                }}
                              >
                                <Checkbox
                                  key={index}
                                  name={subtasks.subTaskName}
                                  className="table-toggle"
                                  toggle
                                  onMouseEnter={() =>
                                    workflowConfigurationStore.setDisableClick(
                                      true,
                                    )
                                  }
                                  onMouseLeave={() =>
                                    workflowConfigurationStore.setDisableClick(
                                      false,
                                    )
                                  }
                                  style={{
                                    marginTop: '-3px',
                                    marginLeft: '-10px',
                                  }}
                                  onChange={(e: SyntheticEvent, data: any) =>
                                    toggleSubOn(
                                      e,
                                      data,
                                      subtasks as TemplateSubTasks,
                                    )
                                  }
                                  defaultChecked={
                                    subtasks.isActive ? true : false
                                  }
                                />
                              </Grid.Column>
                              {getnewsubtaskkey === subtasks.subTaskId ? (
                                <Label
                                  attached="bottom right"
                                  style={{
                                    maxWidth: '156px',
                                    cursor: 'pointer',
                                  }}
                                  onMouseEnter={() =>
                                    workflowConfigurationStore.setDisableClick(
                                      true,
                                    )
                                  }
                                  onMouseLeave={() =>
                                    workflowConfigurationStore.setDisableClick(
                                      false,
                                    )
                                  }
                                >
                                  <Grid columns={7}>
                                    {/* <Grid.Row style={{ justifyContent: "center" }}> */}
                                    <Grid.Column>
                                      <Icon
                                        name="pencil"
                                        color="grey"
                                        size="small"
                                        onClick={() =>
                                          handleEdit(
                                            subtasks.subTaskId,
                                            subtasks.subTaskName,
                                          )
                                        }
                                      />
                                    </Grid.Column>
                                    <Grid.Column
                                      style={{
                                        marginLeft: '2px',
                                      }}
                                    >
                                      <Icon
                                        name="trash"
                                        color="grey"
                                        size="small"
                                        onClick={() =>
                                          handleDeleteSubTask(
                                            subtasks as TemplateSubTasks,
                                          )
                                        }
                                      />
                                    </Grid.Column>

                                    {commonStore.filterModeTwo?.includes(
                                      'SWCB01',
                                    ) ? (
                                      <></>
                                    ) : (
                                      <Grid.Column>
                                        {' '}
                                        <Icon
                                          name="mail"
                                          color="grey"
                                          size="small"
                                          disabled={commonStore.filterModeZero?.includes(
                                            'SWCB01',
                                          )}
                                          onClick={() =>
                                            redirectUserToCommunication(
                                              subtasks as TemplateSubTasks,
                                              '/communication-setting',
                                            )
                                          }
                                        />
                                      </Grid.Column>
                                    )}

                                    {/* <Grid.Column
                                            > <Icon name="mail" color="grey" size="small" 
                                            disabled={dashboardStore.dashboard.selectedUserRoleId.includes('SWCB01')?false:true}
                                            onClick={()=> redirectUserToCommunication(subtasks as TemplateSubTasks,"/communication-setting")} />
                                            </Grid.Column> */}

                                    {commonStore.filterModeTwo?.includes(
                                      'SWAB01',
                                    ) ? (
                                      <></>
                                    ) : (
                                      <Grid.Column>
                                        {' '}
                                        <Icon
                                          name="settings"
                                          color="grey"
                                          size="small"
                                          disabled={commonStore.filterModeZero?.includes(
                                            'SWAB01',
                                          )}
                                          onClick={() =>
                                            redirectUserToCommunication(
                                              subtasks as TemplateSubTasks,
                                              '/apisetting',
                                            )
                                          }
                                        />
                                      </Grid.Column>
                                    )}

                                    {/* <Grid.Column> <Icon name="settings" color="grey" size="small" 
                                            disabled={dashboardStore.dashboard.selectedUserRoleId.includes('SWAB01')?false:true} 
                                            onClick={()=> redirectUserToCommunication(subtasks as TemplateSubTasks,"/apisetting")} />
                                            </Grid.Column> */}

                                    {commonStore.filterModeTwo?.includes(
                                      'SWAB02',
                                    ) ? (
                                      <></>
                                    ) : (
                                      <Grid.Column>
                                        {' '}
                                        <Icon
                                          name="setting"
                                          color="grey"
                                          size="small"
                                          disabled={commonStore.filterModeZero?.includes(
                                            'SWAB02',
                                          )}
                                          onClick={() => {
                                            setAutoRejectSubtaskId(
                                              subtasks?.subTaskId || '',
                                            );
                                            setIsAutoRejectModal(true);
                                          }}
                                        />
                                      </Grid.Column>
                                    )}

                                    {/* <Grid.Column> <Icon name="setting" color="grey" size="small" 
                                            disabled={dashboardStore.dashboard.selectedUserRoleId.includes('SWAB01')?false:true} 
                                            onClick={() => {
                                              setAutoRejectSubtaskId(subtasks?.subTaskId || "");
                                              setIsAutoRejectModal(true);
                                            }} />
                                            </Grid.Column> */}
                                    {/* </Grid.Row> */}
                                  </Grid>
                                </Label>
                              ) : null}
                            </Grid.Row>
                          </Grid>
                        </Card.Content>
                      </Card>
                    </div>
                  )}
                </Draggable>
              );
            })}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );

  return (
    <>
      {isModalOpen && (
        <Suspense fallback={<></>}>
          <DeleteModal
            isModalOpen={isModalOpen}
            closeHandler={() => {
              setIsModalOpen(false);
            }}
            deleteHandler={deleteConfirmed}
            header={'Delete'}
            text={
              'Are you sure you want to delete this? Deleting it will also remove all related data.'
            }
          />
        </Suspense>
      )}
      <div>
        {isAutoRejectModal && (
          <AutoRejectSetting
            subtaskId={autoRejectSubTaskId || ''}
            modalCloseHandler={() => setIsAutoRejectModal(false)}
          />
        )}
        <Grid>
          <Card style={cardStyleLevel2}>
            <Header
              style={{ marginLeft: '20px', padding: '10px' }}
              size="huge"
              as="h1"
              content="subTask"
              sub
              color="grey"
            />
            {!selectedTasks || loadingInitialST ? (
              <LoadingComponent />
            ) : (
              SubTaskDataJSX
            )}
            <Segment className="workflow-bottom-card">
              <Form>
                <Form.Group widths="equal">
                  <Form.Field
                    id="form-input-control-error-email"
                    className=" workflow-input"
                    error={
                      errorType === 'SameName'
                        ? errorMessageText
                        : errorType === 'EmptyName'
                          ? errorEmptyText
                          : errorType === 'dot'
                            ? errorDot
                            : null
                    }
                    control={Input}
                    value={newSubtasks}
                    placeholder="Create New"
                    onChange={handleChangeName}
                    onKeyDown={handleKeyPress}
                  />
                </Form.Group>
              </Form>
              {workflowConfigurationStore.WorkflowConfiguration
                .editClickedSubtask === false ? (
                <div className="workflow-input-div">
                  {commonStore.filterModeTwo?.includes('SWB08') ? (
                    <></>
                  ) : (
                    <Button
                      primary
                      onClick={handleClone}
                      className="workflow-input-button"
                      disabled={
                        commonStore.filterModeZero?.includes('SWB08') ||
                        errorType !== ''
                      }
                    >
                      {' '}
                      Clone{' '}
                    </Button>
                  )}

                  {/* <Button primary onClick={handleClone} className="workflow-input-button" 
                disabled={!dashboardStore.dashboard.selectedUserRoleId.includes("SWB08")?true:false ||
                errorType === "SameName" || errorType === "EmptyName" ? true : false } 
                error={errorType==='SameName'?errorMessageText:errorType==='EmptyName'?errorEmptyText:null}>  Clone </Button> */}

                  {commonStore.filterModeTwo?.includes('SWB06') ? (
                    <></>
                  ) : (
                    <Button
                      color="green"
                      floated="right"
                      onClick={hanldeAddSubTasks}
                      className="workflow-input-button"
                      disabled={
                        commonStore.filterModeZero?.includes('SWB06') ||
                        errorType !== ''
                      }
                      error={
                        errorType === 'SameName'
                          ? errorMessageText
                          : errorType === 'EmptyName'
                            ? errorEmptyText
                            : errorType === 'selectionEmpty'
                              ? selectionEmptyErrorMsg
                              : null
                      }
                    >
                      {' '}
                      Add New{' '}
                    </Button>
                  )}

                  {/* <Button color="green" floated="right" onClick={hanldeAddSubTasks} className="workflow-input-button" 
                disabled={!dashboardStore.dashboard.selectedUserRoleId.includes("SWB06")?true:false ||
                errorType === "SameName" || errorType === "EmptyName" ? true : false } 
                 error={errorType==='SameName'?errorMessageText:errorType==='EmptyName'?errorEmptyText:null}> Add New </Button> */}
                </div>
              ) : (
                <div className="workflow-input-div">
                  <Button
                    secondary
                    onClick={() => handleSaveEdited('cancel')}
                    className="workflow-input-button"
                  >
                    {' '}
                    Cancel{' '}
                  </Button>
                  <Button
                    primary
                    floated="right"
                    onClick={() => handleSaveEdited('edit')}
                    className="workflow-input-button"
                    error={
                      errorType === 'SameName'
                        ? errorMessageText
                        : errorType === 'EmptyName'
                          ? errorEmptyText
                          : null
                    }
                  >
                    {' '}
                    Save{' '}
                  </Button>
                </div>
              )}
            </Segment>
          </Card>
          {workflowConfigurationStore.WorkflowConfiguration
            .showElementTypesCard &&
          workflowConfigurationStore.WorkflowConfiguration.showTemplateCard &&
          workflowConfigurationStore.WorkflowConfiguration.showTaskCard &&
          workflowConfigurationStore.WorkflowConfiguration.showSubTaskCard &&
          workflowConfigurationStore.WorkflowConfiguration.showSubTaskClicked &&
          workflowConfigurationStore.WorkflowConfiguration.showElementCard &&
          workflowConfigurationStore.WorkflowConfiguration
            .showElementClicked === true ? (
            <WorkflowSettingsElements />
          ) : null}
        </Grid>
      </div>
    </>
  );
}

export default observer(WorkflowSubtasks);
